import Menu from './menu';

export default class InfoPanel extends Menu {
    private titleEl: HTMLElement = document.querySelector('#info-modal-title')!;
    private bodyEl: HTMLElement = document.querySelector('#info-modal-body')!;
    private closeBtn: HTMLElement = document.querySelector('#info-modal-close')!;

    public constructor() {
        super('#info-modal');
        this.closeBtn.addEventListener('click', () => this.hide());
    }

    public showInfo(title: string, text: string): void {
        this.titleEl.textContent = title;
        this.bodyEl.textContent = text;
        this.container.hidden = false;
    }

    public override hide(): void {
        this.container.hidden = true;
    }
}
